import type { InternalAxiosRequestConfig } from 'axios';
import { readUsableWorkingProject } from '@vnetwork/margarita-shell/iam';

// Compute and Managed Kubernetes v2 need the project only to CREATE something: the machine or
// cluster is made inside a project, named by the `X-Project-ID` header. Reads, updates and
// deletes do not take it. This interceptor adds the project the user is working in to a POST
// of the client's create path, unless the call already names one (`useCreateInstance` does,
// from its form). The project is the one the top bar shows (`useWorkingProject`, published by `WorkingProjectSync`),
// and only once it was checked against the project lists: with none chosen, or one not yet (or no longer) known to
// be usable, the interceptor changes nothing and never sends the raw stored id.

/** Request interceptor for a client: `createPath` matches the URL of its create request. */
export function withProjectOnCreate(createPath: RegExp) {
  return function withProject(config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
    if (config.method?.toLowerCase() !== 'post' || !createPath.test(config.url ?? '')) return config;
    if (config.headers.has('X-Project-ID')) return config;
    const { project, settled } = readUsableWorkingProject();
    if (project && settled) config.headers.set('X-Project-ID', project.projectId);
    return config;
  };
}
